import { Injectable } from '@angular/core';

import { NOT_APPLICABLE, TrackData, TrackingService, trackingConstants } from '@frontend/sports/tracking/feature';
import { TrackingData } from '@frontend/vanilla/core';

import { PickSourceProvider } from '../option-pick/pick-source.provider';
import { TopEventsPodData, TopEventsTrackingData, TrackingEvent } from './top-events.model';

@Injectable()
export class TopEventsTrackingService {
    constructor(
        private trackingService: TrackingService,
        private pickSourceProvider: PickSourceProvider,
    ) {}

    trackShowMoreLess(pod: TopEventsPodData, index: number, isExpanded: boolean): void {
        this.trackingService.track(
            trackingConstants.EVENT_TRACKING,
            this.getBaseTrackingData({
                actionEvent: TrackingEvent.Click,
                positionEvent: pod.podType,
                locationEvent: pod.title,
                eventDetails: isExpanded ? 'show less' : 'show more',
                leagueId: Object.keys(pod.trackingInfo).join(','),
                marketId: Object.values(pod.trackingInfo).join(','),
                contentPosition: index,
            }),
        );
    }

    trackEventHeaderClick(pod: TopEventsPodData, index: number): void {
        this.trackingService.track(
            trackingConstants.EVENT_TRACKING,
            this.getBaseTrackingData({
                actionEvent: TrackingEvent.Click,
                positionEvent: pod.podType,
                locationEvent: pod.title,
                eventDetails: pod.title,
                leagueId: Object.keys(pod.trackingInfo).join(','),
                marketId: Object.values(pod.trackingInfo).join(','),
                contentPosition: index,
            }),
        );
    }

    trackBottomLink(pod: TopEventsPodData, index: number): void {
        this.trackingService.track(
            trackingConstants.EVENT_TRACKING,
            this.getBaseTrackingData({
                actionEvent: TrackingEvent.Click,
                positionEvent: pod.podType,
                locationEvent: pod.title,
                eventDetails: 'SeeAll',
                leagueId: Object.keys(pod.trackingInfo).join(','),
                marketId: Object.values(pod.trackingInfo).join(','),
                contentPosition: index,
            }),
        );
    }

    trackPodExpansion(pod: TopEventsPodData, index: number, title: string): void {
        this.trackingService.track(
            trackingConstants.EVENT_TRACKING,
            this.getBaseTrackingData({
                actionEvent: pod.isExpanded ? TrackingEvent.Expand : TrackingEvent.Collapse,
                positionEvent: pod.podType,
                locationEvent: pod.title || title,
                eventDetails: pod.title || title,
                leagueId: pod.trackingInfo ? Object.keys(pod.trackingInfo).join(',') : '',
                marketId: pod.trackingInfo ? Object.values(pod.trackingInfo).join(',') : '',
                contentPosition: index,
            }),
        );
    }

    trackWidgetLoad(podData: TopEventsPodData[]): void {
        const data: TrackingData = {
            [trackingConstants.TOPEVENTS_POD_DATA]: podData.map((pod, index) => ({
                ...this.getBaseTrackingData({
                    actionEvent: TrackingEvent.PodLoaded,
                    positionEvent: pod.podType,
                    eventDetails: NOT_APPLICABLE,
                    leagueId: Object.keys(pod.trackingInfo).join(','),
                    marketId: Object.values(pod.trackingInfo).join(','),
                    contentPosition: index,
                }),
                sitecoreTemplateId: pod.podId.substring(1, pod.podId.length - 1),
                ...this.pickSourceProvider.getTracking(),
            })),
        };
        this.trackingService.track(trackingConstants.EVENT_PODVIEW, data);
    }

    private getBaseTrackingData(topEventsTrackingData: TopEventsTrackingData): TrackData {
        return {
            [trackingConstants.COMPONENT_CATEGORY_EVENT]: 'Top Items Modules',
            [trackingConstants.COMPONENT_LABEL_EVENT]: 'Top Events',
            [trackingConstants.COMPONENT_ACTION_EVENT]: topEventsTrackingData.actionEvent,
            [trackingConstants.COMPONENT_POSITION_EVENT]: topEventsTrackingData.positionEvent,
            [trackingConstants.COMPONENT_LOCATION_EVENT]: topEventsTrackingData.locationEvent,
            [trackingConstants.COMPONENT_EVENT_DETAILS]: topEventsTrackingData.eventDetails,
            [trackingConstants.COMPONENT_URL_CLICKED]: NOT_APPLICABLE,
            [trackingConstants.SPORT_LEAGUE_ID]: topEventsTrackingData.leagueId,
            [trackingConstants.MARKET_ID]: topEventsTrackingData.marketId,
            [trackingConstants.COMPONENT_CONTENT_POSITION]: topEventsTrackingData.contentPosition,
            [trackingConstants.COMPONENT_MODULE_TYPE]: topEventsTrackingData.positionEvent,
        };
    }
}
